import './Company.css'
import {TopMenu} from "../../top-menu/TopMenu";
import {Footer} from "../../footer/Footer";
import CompanyImage from '../../../assets/company.png';
import AISC from "../../../assets/aisc.png";
import NISD from "../../../assets/nisd.png";
import SDS from "../../../assets/sds2_certification-badge__Detailer.png";

export const Company = () => {
    return (
        <div className="App">
            <TopMenu/>
            <div className="main-container three-column-container">
                <div className="history-text-container">
                    <h1 className="page-title">HISTORY</h1>
                    <p>We have always operated at the leading edge of technology utilizing the latest in CAD, modeling, printing, scanning, BIM technology, etc, since 1993.</p>
                    <p>We have been using SDS2 to model and detail shop drawings for our projects since 1998 and have progressed with technology advancements.</p>
                    <p>Our staff has experience in all fields of structural & miscellaneous steel including modeling, detailing, fabrication, and erection.</p>
                    <p>With a specialization in complex structural and miscellaneous steel projects, we prepare high-quality shop drawings and models that ensure seamless fabrication and erection for our commercial, public works, and private projects.</p>
                    <p>Jim Truitt, a respected leader in the steel industry, founded Rocky Point Detailing LLC and Aircad LLC in 1993. Under his leadership, the companies have successfully completed over 500 steel detailing projects, and his educational outreach has helped train hundreds of industry professionals. As a board member for the National Institute of Steel Detailers (NISD), Jim is an active advocate for quality and training, working to educate industry stakeholders on best practices. Jim is also a private pilot and enjoys flying to visit clients and jobsites throughout the western United States.</p>
                </div>
                <div className="two-columns-container">
                    <div className="company-image-wrapper">
                        <img src={CompanyImage}/>
                    </div>
                    <div className="company-more-info-wrapper">
                        <div className="expand"></div>
                        <div className="memberships-wrapper">
                            <h2 className="memberships-text-company">Certifications</h2>
                            <div className="memberships-logos-wrapper memberships-logos-company-wrapper">
                                <div>
                                    <img src={SDS}/>
                                </div>
                            </div>
                            <p>NISD CLASS I & II DETAILERS <br/>
                                SDS2 CERTIFIED DETAILERS</p>
                        </div>
                        <div className="memberships-wrapper">
                            <h2 className="memberships-text-company">Memberships</h2>
                            <div className="memberships-logos-wrapper memberships-logos-company-wrapper">
                                <div>
                                    <img src={AISC}/>
                                </div>
                                <div className="memrbership-logo">
                                    <img src={NISD}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}